import { LoadingService } from '../../../core/services/loading/loading.service'
import { AsyncPipe } from '@angular/common'
import { Component, inject } from '@angular/core'
import { BndLoading } from '@bonduelle-it/storybook'
import { TranslatePipe } from '@ngx-translate/core'
import { Observable } from 'rxjs'
@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss'],
  imports: [BndLoading, AsyncPipe, TranslatePipe],
})
export class LoadingScreenComponent {
  private loadingService = inject(LoadingService)

  get active$(): Observable<boolean> {
    return this.loadingService.status$
  }
}
